import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import authDataSlice from "./Slices/authSlice";
import profileSlice from "./Slices/profileSlice";
import adminSlice from "./Slices/adminSlice";
import publicSlice from "./Slices/publicSlice";
import listSlice from "./Slices/listSlice";
import searchListSlice from "./Slices/searchSlice";
import lccSlice from "./Slices/lccSlice";
import pastSlice from "./Slices/pastSlice";
import bankingSlice from "./Slices/bankingSlice";
import CapacitySlice from "./Slices/CapacitySlice";
import activeRegionSlice from "./Slices/activeRegionSlice";
import activeEntitySlice from "./Slices/activeEntitySlice";
import scheduleSlice from "./Slices/scheduleSlice";
import notificationSlice from "./Slices/notificationSlice";
import auctionSlice from "./Slices/auctionSlice";
import paymentSlice from "./Slices/paymentSlice";
import listingStatusSlice from "./Slices/buySellhasApprovedAndPending";
import activeSubTabSlice from "./Slices/activeSubTabSlice";
import companyAdminSlice from "./Slices/companyAdminSlice";
import messageSlice from "./Slices/messageSlice";
import gnaAdminSlice from "./Slices/gnaAdminSlice";
import unifiedLedgerSlice from "./Slices/unifiedLedgerSlice";
import platformSlice from "./Slices/platformSlice";
import BankingCalcSlice from "./Slices/BankingCalcSlice";
import reconciliationSlice from "./Slices/reconciliationSlice";
import contractsSlice from "./Slices/contractsSlice";
import tokenAccessArchiveSlice from "./Slices/tokenAccessArchiveSlice";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, authDataSlice);

export const store = configureStore({
  reducer: {
    persistedReducer: persistedReducer,
    activeRegion: activeRegionSlice,
    activeEntity: activeEntitySlice,
    profileSlice: profileSlice,
    publicSlice: publicSlice,
    // documentSlice: documentSlice,
    adminSlice: adminSlice,
    listSlice: listSlice,
    searchListSlice: searchListSlice,
    lccSlice: lccSlice,
    pastSlice: pastSlice,
    bankingSlice: bankingSlice,
    CapacitySlice: CapacitySlice,
    scheduleSlice: scheduleSlice,
    notificationSlice: notificationSlice,
    auctionSlice: auctionSlice,
    paymentSlice: paymentSlice,
    listingStatusSlice: listingStatusSlice,
    companyAdminSlice: companyAdminSlice,
    activeSubTabSlice: activeSubTabSlice,
    messageSlice: messageSlice,
    gnaAdminSlice: gnaAdminSlice,
    unifiedLedger: unifiedLedgerSlice,
    platformSlice: platformSlice,
    bankingCalcSlice: BankingCalcSlice,
    reconciliation: reconciliationSlice,
    contracts: contractsSlice,
    tokenAccessArchive: tokenAccessArchiveSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
